﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG } from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederGenerellAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederGenerellAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederGenerellAppState, {}, AnyAction>, getState: () => VeilederGenerellAppState): void => {
        dispatch(setVisning({ }));
    };
};

